// Claude 3.7 Sonnet API integration
// API key stored directly in this file
const CLAUDE_API_KEY = 'YOUR_CLAUDE_API_KEY_HERE'; // Replace with your actual Claude API key

export async function fetchClaudeResponse(prompt, fileData = null) {
    const endpoint = 'https://api.anthropic.com/v1/messages';
    
    try {
        let messageContent;
        
        if (fileData) {
            if (fileData.fileType === 'text' && fileData.textContent) {
                // Handle text files - include content in prompt
                messageContent = [
                    {
                        type: "text",
                        text: `${prompt}\n\nFile Content (${fileData.fileName}):\n${fileData.textContent}`
                    }
                ];
            } else if (fileData.fileType === 'image' && fileData.imageData) {
                // Handle images with vision capabilities
                messageContent = [
                    {
                        type: "image",
                        source: {
                            type: "base64",
                            media_type: fileData.mimeType,
                            data: fileData.imageData
                        }
                    },
                    {
                        type: "text",
                        text: prompt
                    }
                ];
            } else if (fileData.imageData && (fileData.fileType === 'pdf' || fileData.fileType === 'office' || fileData.fileType === 'video')) {
                // For PDFs and office docs, Claude might support them as documents
                messageContent = [
                    {
                        type: "text",
                        text: `${prompt}\n\nI've uploaded a ${fileData.fileType.toUpperCase()} file named "${fileData.fileName}" with MIME type "${fileData.mimeType}". Please analyze this file type and provide relevant information based on my prompt.`
                    }
                ];
            } else {
                // Fallback for other file types
                messageContent = [
                    {
                        type: "text",
                        text: `${prompt}\n\nI've uploaded a file: ${fileData.fileName} (${fileData.fileType}). Please provide information about this file type and help with my request.`
                    }
                ];
            }
        } else {
            // Handle text-only input
            messageContent = [
                {
                    type: "text",
                    text: prompt
                }
            ];
        }

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': CLAUDE_API_KEY,
                'anthropic-version': '2023-06-01'
            },
            body: JSON.stringify({
                model: 'claude-3-5-sonnet-20241022',
                max_tokens: 1024,
                temperature: 0.7,
                messages: [
                    {
                        role: 'user',
                        content: messageContent
                    }
                ]
            })
        });

        if (!response.ok) {
            throw new Error(`Claude API error: ${response.status}`);
        }

        const data = await response.json();
        
        // Extract the response text from Claude's response structure
        let result = data.content?.[0]?.text || 'No response from Claude API';
        
        // Replace any mention of Google with ChatBox AI
        result = result.replace(/\b[Gg]oogle\b/g, "ChatBox AI");
        result = result.replace(/\bChatbox AI\b/g, "ChatBox AI");
        
        return result;
        
    } catch (error) {
        console.error('Claude API Error:', error);
        return `Error: Unable to fetch response from Claude 3.7 Sonnet. ${error.message}`;
    }
}
